/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * The draft's language, French when missing; an improvement keeps the language of the description
 */
export enum ImproveHubDescriptionRequestLocale {
  en = 'en',
  fr = 'fr',
  es = 'es'
}
